import React from 'react';
import './tablePopUp.scss';
import { BsChevronDoubleDown } from 'react-icons/bs';
import DisplayTable from '../../../reusable-components/DisplayTable/DisplayTable';
import { mls } from 'lib/multilanguagesupport';

interface mainProps {
  isTablePopUp: boolean;
  setIsTablePopUp: Function;
  tableData: any[];
  tableLoading: boolean;
}
const TablePopUp = (props: mainProps) => {
  const { setIsTablePopUp, tableData, tableLoading } = props;

  return (
    <div
      className='tableOuterContainer'
      style={{
        // maxWidth: mainContainerWidth ? mainContainerWidth * 1 : 'auto',
        // maxWidth: `calc(${mainContainerWidth}px - 4rem)`,
        maxWidth: `calc(100% - 4rem)`,
        left: '2.5rem',
        minHeight: '300px',
      }}
    >
      <div className='tableHeaderDiv'>
        <div className='tableHeaderTitle'>{mls("Table's Head Rows")}</div>

        <div className='closeDiv' onClick={() => setIsTablePopUp(false)}>
          <BsChevronDoubleDown />
        </div>
      </div>
      <DisplayTable tableData={tableData} tableLoading={tableLoading} />
    </div>
  );
};

export default TablePopUp;
